import { render } from "./FeeStructureManagement.vue?vue&type=template&id=d01bbf12&scoped=true"
import script from "./FeeStructureManagement.vue?vue&type=script&lang=js"
export * from "./FeeStructureManagement.vue?vue&type=script&lang=js"

import "./FeeStructureManagement.vue?vue&type=style&index=0&id=d01bbf12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d01bbf12"]])

export default __exports__